"use client";
import cookies from 'js-cookie';
import React, { useEffect, useMemo } from 'react';
import { COOKIES } from '@sravni/utils/lib/consts';
import { ATTR_NAME } from '@sravni/utils/lib/theme';
import { isBrowser } from '../../utils/dom.js';
import { COOKIE_MAX_AGE } from './consts.js';
import { ThemeContext } from './Context.js';

function UncontrolledThemeProvider(props) {
    const { initialTheme, children } = props;
    const [currentTheme, setCurrentTheme] = React.useState(initialTheme);
    const setTheme = React.useCallback(
    // isTrusted - true if function called by user action
    (theme, isTrusted = true) => {
        if (isTrusted) {
            cookies.set(COOKIES.USER_THEME, theme, {
                expires: new Date(new Date().getTime() + COOKIE_MAX_AGE),
                sameSite: 'Lax',
                path: '/',
            });
        }
        setCurrentTheme(theme);
    }, [setCurrentTheme]);
    useEffect(() => {
        if (!isBrowser) {
            return;
        }
        const node = document.documentElement;
        node?.setAttribute(ATTR_NAME, currentTheme);
    }, [currentTheme]);
    const value = useMemo(() => ({ theme: currentTheme, setTheme }), [currentTheme, setTheme]);
    return React.createElement(ThemeContext.Provider, { value: value }, children);
}

export { UncontrolledThemeProvider };
//# sourceMappingURL=Uncontrolled.js.map
